import parse from 'html-react-parser';

const md = require('markdown-it')({
	html: true, // Enable HTML tags in source
	xhtmlOut: false,
	breaks: true,
	langPrefix: 'language-',
	linkify: true,
	typographer: true,
	quotes: '“”‘’',
	highlight(/* str, lang */) {
		return '';
	},
});

const domNodeCheck = ['h1', 'h2', 'h3', 'h4', 'h5', 'h5', 'p', 'ul', 'li'];

const parseOption = {
	// eslint-disable-next-line consistent-return
	replace: (domNode) => {
		if (domNode.attribs && domNode.name === 'a') {
			// eslint-disable-next-line no-param-reassign
			domNode.attribs = {
				...domNode.attribs,
				target: '_blank',
				rel: 'noreferrer noopener',
				class: 'md2react-a-tag',
			};
			return domNode;
		}
		if (domNode.attribs && domNodeCheck.indexOf(domNode.name) >= 0) {
			// eslint-disable-next-line no-param-reassign
			domNode.attribs = {
				...domNode.attribs,
				class: `md2react-${domNode.name}-tag`,
			};
			return domNode;
		}
	},
};

// eslint-disable-next-line import/prefer-default-export
export const convert2HtmlEntities = (text) => {
	if (text === undefined) {
		return '';
	}

	return parse(md.render(text), parseOption);
};
